import { useState, useContext, useEffect } from 'react'
import { Input, FormControl, Select, MenuItem } from '@mui/material'
import WizardDataContext from '../../../store/WizardDataContext';

export default function CouponType({ setDisableBtn }) {

  const wizardCtx = useContext(WizardDataContext);
  const { wizardData, updateData } = wizardCtx;
  const couponType = wizardData.couponType;

  useEffect(() => {
    // Check if deal value is valid (not empty and is a number)
    const dealValue = couponType.deal;
    const isValid = dealValue !== '' && dealValue !== null && dealValue !== undefined && !isNaN(dealValue) && dealValue > 0;
    setDisableBtn(!isValid);
  }, [couponType.deal, setDisableBtn])

  const handleCoupon1Deal = (e) => {
    let newDeal = e.target.value
    // Allow empty values and only set if there's a value
    const dealValue = newDeal === '' ? '' : newDeal
    updateData('couponType', { 
      deal: dealValue, 
      dealUnit: 'Free',
      dealItem: couponType.dealItem || 'T-Shirt' 
    })
  }
  
  const handleCoupon1Type = (e) => {
    let newType = e.target.value
    updateData('couponType', { 
      dealItem: newType,
      dealUnit: 'Free' 
    })
  }
  
  const handleCoupon2 = (e) => {
    let newDeal = e.target.value
    // Allow empty values and only set if there's a value
    const dealValue = newDeal === '' ? '' : newDeal
    updateData('couponType', { 
      deal: dealValue, 
      dealUnit: 'PER'
    })
  }
  
  const handleCoupon3 = (e) => {
    let newDeal = e.target.value
    // Allow empty values and only set if there's a value
    const dealValue = newDeal === '' ? '' : newDeal
    const currency = couponType.currency || 'zar'
    updateData('couponType', { 
      deal: dealValue, 
      dealUnit: getCurrencyLabel(currency),
      currency: currency     
    })
  }

  const handleCurrencyChange = (e) => {
    let newCurrency = e.target.value
    updateData('couponType', { 
      currency: newCurrency,
      dealUnit: getCurrencyLabel(newCurrency)
    })
  }

  const changeActiveTab = (tab, dealUnit) => {
    
    const newData = {
      deal: '', // Start with empty value
    };
    
    if (tab === 1) {
      newData.dealUnit = 'Free';
      newData.dealItem = couponType.dealItem || 'T-Shirt';
    } else if (tab === 2) {
      newData.dealUnit = 'PER';
    } else if (tab === 3) {
      const currency = couponType.currency || 'zar';
      newData.dealUnit = getCurrencyLabel(currency);
      newData.currency = currency;
    }
    
    updateData('couponType', { 
      activeTab: tab, 
      ...newData
    })
  }
  
  const getDealValue = (tab) => {
    if (couponType.activeTab === tab) {
      const value = couponType.deal;
      
      // Return empty string if no value, otherwise return the value
      if (value === '' || value === null || value === undefined) {
        return '';
      }
      
      return tab === 3 ? -value : value;
    }
    
    // For inactive tabs, show placeholder values
    if (tab === 1) return '1';
    if (tab === 2) return '1';
    if (tab === 3) return '1'; 
    return '';
  }

  
  const getInputValue = (tab) => {
    if (couponType.activeTab === tab) {
      return couponType.deal || '';
    }
    
    // For inactive tabs, show empty string
    if (tab === 1) return '1';
    if (tab === 2) return '1';
    if (tab === 3) return '1';
    return '';
  }

  const getCurrencyLabel = (currency) => {
    const currencyMap = {
      'zar': 'ZAR',
      'usd': 'USD',
      'aud': 'AUD',
      'inr': 'INR'
    }
    return currencyMap[currency] || 'ZAR'
  }

  return (
    <>
      <div className="coupon-select-container">

        <div className="coupon-select-header">
          <h1>Select the type of offer you wish to create</h1>
        </div>

        <div className="coupon-container">
          <div className="coupon-card" style={couponType.activeTab === 1 ? { border: "2px solid #0A71F5" } : { filter: "saturate(0%)", color: "#c4c4ce" }} onClick={() => changeActiveTab(1, 'FREE')}>
            {couponType.activeTab === 1 && (
              <div className="coupon-sub-text">
                Offer a FREE Item
              </div>
            )}
            
            <div className="coupon-head" >
              <h1>{getDealValue(1)}</h1>
              <span>{couponType.dealItem}</span>
              <h2>FREE</h2>
            </div>
            <div
              className="coupon-inputs"
              style={{ pointerEvents: couponType.activeTab === 1 ? 'auto' : 'none' }}
            >
              <Input 
                value={couponType.activeTab === 1 ? getInputValue(1) : getDealValue(1)} 
                readOnly={couponType.activeTab !== 1}
                inputProps={{ tabIndex: couponType.activeTab === 1 ? 0 : -1 }}
                onChange={(e) => handleCoupon1Deal(e)} 
                onClick={(e) => e.stopPropagation()}
              />
              <Input 
                value={couponType.dealItem} 
                readOnly={couponType.activeTab !== 1}
                inputProps={{ tabIndex: couponType.activeTab === 1 ? 0 : -1 }}
                onChange={(e) => handleCoupon1Type(e)} 
                onClick={(e) => e.stopPropagation()}
              />
              <span className='coupon-bottom-text'>FREE</span>
            </div>

            <div className="coupon-select" style={couponType.activeTab === 1 ? { background: "#0A71F5", width: "20px", height: "20px" } : { width: "20px", height: "20px" }}>
            </div>
          </div>

          <div className="coupon-card" style={couponType.activeTab === 2 ? { border: "2px solid #0A71F5" } : { filter: "saturate(0%)", color: "#c4c4ce" }} onClick={() => changeActiveTab(2, 'PER')}>
            {couponType.activeTab === 2 && (
              <div className="coupon-sub-text">
                Offer a Percentile Discount
              </div>
            )}
            
            <div className="coupon-head" >
              <h1 style={{ marginBottom: "0" }} >{getDealValue(2)}%</h1>
              <h2 style={{ marginTop: "0px" }}>OFF</h2>
            </div>

            <div
              className="coupon-inputs"
              style={{ pointerEvents: couponType.activeTab === 2 ? 'auto' : 'none' }}
            >
              <Input 
                value={couponType.activeTab === 2 ? getInputValue(2) : getDealValue(2)} 
                style={{ marginTop: "50px" }} 
                readOnly={couponType.activeTab !== 2}
                inputProps={{ tabIndex: couponType.activeTab === 2 ? 0 : -1 }}
                onChange={(e) => handleCoupon2(e)} 
                onClick={(e) => e.stopPropagation()}
              />
              <span className='coupon-bottom-text'>% OFF</span>
            </div>

            <div className="coupon-select" style={couponType.activeTab === 2 ? { background: "#0A71F5", width: "20px", height: "20px" } : { width: "20px", height: "20px" }}>
            </div>
          </div>

          <div className="coupon-card" style={couponType.activeTab === 3 ? { border: "2px solid #0A71F5" } : { filter: "saturate(0%)", color: "#c4c4ce" }} onClick={() => changeActiveTab(3, getCurrencyLabel(couponType.currency || 'zar'))}>
            {couponType.activeTab === 3 && (
              <div className="coupon-sub-text">
                Offer a Monetary Discount
              </div>
            )}
            
            <div className="coupon-head">
              <h1 style={{ marginBottom: "0" }} >{getDealValue(3)}</h1>
              <h2 style={{ marginTop: "0px" }} >{getCurrencyLabel(couponType.currency)}</h2>
            </div>

            <div
              className="coupon-inputs"
              style={{ pointerEvents: couponType.activeTab === 3 ? 'auto' : 'none' }}
            >
              <Input 
                value={couponType.activeTab === 3 ? getInputValue(3) : getDealValue(3)} 
                style={{ marginTop: "50px" }} 
                readOnly={couponType.activeTab !== 3}
                inputProps={{ tabIndex: couponType.activeTab === 3 ? 0 : -1 }}
                onChange={(e) => handleCoupon3(e)} 
                onClick={(e) => e.stopPropagation()}
              />
              <FormControl variant="standard" sx={{ width: '8ch' }}>
                <Select
                  labelId="currency-select-label"
                  id="currency-select"
                  value={couponType.currency || 'zar'}
                  onChange={handleCurrencyChange}
                  defaultValue={'zar'}
                  disabled={couponType.activeTab !== 3}
                  onClick={(e) => e.stopPropagation()}
                >
                  <MenuItem value={'zar'}>ZAR</MenuItem>
                  <MenuItem value={'usd'}>USD</MenuItem>
                  <MenuItem value={'aud'}>AUD</MenuItem>
                  <MenuItem value={'inr'}>INR</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="coupon-select" style={couponType.activeTab === 3 ? { background: "#0A71F5", width: "20px", height: "20px" } : { width: "20px", height: "20px" }}>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
